
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type boughtTogetherRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function boughtTogetherRT(): TemplateResult<boughtTogetherRTRootProps> {
    function repeatItems1(items, itemsIndex) {
        return [items(function () {
                function mergeProps(inline, external) {
                    var res = Object.assign({}, inline, external);
                    if (inline.hasOwnProperty('style')) {
                        res.style = _.defaults(res.style, inline.style);
                    }
                    if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
                        res.className = external.className + ' ' + inline.className;
                    }
                    return res;
                }
                return _createElement('div', {
                    'onClick': this.selectItem,
                    'className': 'cm_bought-together-product-container ' + (this.isSelected ? 'cm_selected' : '')
                }, _createElement('div', { 'className': 'cm_checkbox' }, this.isSelected && '\u2713'), _createElement('div', { 'className': 'cm_bought-together-together-product' }, _createElement('div', { 'className': 'cm_bought-together-product-image' }, _createElement('img', {
                    'src': this.imageOrDefault(this.image),
                    'alt': 'Image of ' + this.removeHTML(this.title),
                    'onError': this.onImageError
                })), _createElement('a', mergeProps({
                    'href': this.url,
                    'target': '_blank',
                    'className': 'cm_bought-together-product-title'
                }, { dangerouslySetInnerHTML: { __html: typeof this.title === 'undefined' ? '' : this.title } })), _createElement('div', { 'className': 'cm_bought-together-product-price' }, this.formatPrice(this.price))));
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_bought-together' }, _createElement('div', { 'className': 'cm_bought-together-title-container' }, _createElement('h2', { 'className': 'cm_bought-together-title' }, _translate(`bought_together_title`))), _createElement.apply(this, [
        'div',
        { 'className': 'cm_bought-together-list cmRepeater_items' },
        _map(this.items, repeatItems1.bind(this))
    ]), this.totalPrice ? _createElement('div', {
        'className': 'cm_bought-together_buttons',
        'key': '1942'
    }, _createElement('div', { 'className': 'cm_bought-together_total-price' }, _createElement('span', { 'className': 'cm_bought-together_total-price-title' }, _translate(`bought_together_price`)), '\n      ', this.totalPrice, '\n    '), _createElement('div', { 'className': 'cm_bought-together_button-container' }, _createElement('button', {
        'onClick': this.addItemsToCart,
        'className': 'cm_bought-together_button btn btn--primary'
    }, '\n        ', _translate(`bought_together_button_text`), '\n      '))) : null);
}
        export const componentNames = []